import React from "react";
import PropTypes from "prop-types";

const DaajiMessageInner = ({ homeProp, eventInfo }) => {
  if (homeProp && eventInfo.length < 1) {
    return null;
  }

  const downloadPdf = (language) => {
    const link =
      eventInfo?.find((item) => item?.language === language)?.link || "#";
    const a = document.createElement("a");
    a.target = "_blank";
    a.href = link;
    a.click();
  };
  const messages = eventInfo?.filter(function _(message) {
    return !message.primary;
  });
  return (
    <div className="daaji_wrrapper inner">
      <div className="container">
        {eventInfo.length > 0 && (
          <div className="daaji_box">
            <h6 className="mb-4">
              Download in other languages:
              <br />
            </h6>
            <div className="row">
              {eventInfo
                ?.filter(function _(message) {
                  return !message.primary;
                })
                .map(function _(item) {
                  return (
                    <div className="col-sm-6 col-md-3">
                      <div
                        role="button"
                        tabIndex={0}
                        className="message-contents"
                        onClick={() => {
                          downloadPdf(item.language);
                        }}
                        onKeyDown={() => {
                          downloadPdf(item.language);
                        }}
                      >
                        {item.language}
                      </div>
                    </div>
                  );
                })}
              {messages.length === 0 && <p>Coming soon...</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DaajiMessageInner.propTypes = {
  homeProp: PropTypes.bool,
  eventInfo: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      language: PropTypes.string,
    })
  ),
};

DaajiMessageInner.defaultProps = {
  homeProp: false,
  eventInfo: [],
};

export default DaajiMessageInner;
